import { render, staticRenderFns } from "./LeadsHistory.vue?vue&type=template&id=93240e1e&scoped=true"
import script from "./LeadsHistory.vue?vue&type=script&lang=js"
export * from "./LeadsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93240e1e",
  null
  
)

export default component.exports